import axios from "./axios";

export default {
    getCustomersByNITAndNCR(data) {
        // console.log(`getCustomersByNITAndNCR`, data);
        const options = {
            method: "GET",
            url: "managecustomer/getByNITAndNRC",
            headers: { "content-type": "application/json" },
            params: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.message)
                });
        });
    },

    getCustomersByNITAndNCRBatch(data) {
        const options = {
            method: "POST",
            url: "managecustomer/getByNITAndNRCBatch",
            headers: { "content-type": "application/json" },
            data: { emitters: data },
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.message);
                });
        });
    },

    importingWithholdingCertificates(data) {
        const options = {
            method: "POST",
            url: "importingWithholdingCertificates",
            headers: { "content-type": "multipart/form-data" },
            noAutomaticRetry: true,
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    importingWithholdingCertificatesBatch(data) {
        const options = {
            method: "POST",
            url: "/importingWithholdingCertificates/batch",
            headers: { "content-type": "application/json" },
            noAutomaticRetry: true,
            data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    getImportingWithholdingCertificatesBatchStatus(batchId) {
        const options = {
            method: "GET",
            url: `/importingWithholdingCertificates/batch/${encodeURIComponent(batchId)}`,
            headers: { "content-type": "application/json" },
            noAutomaticRetry: true,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    verifyDuplicatedEntries(value) {
            const options = {
                method: 'GET',
                url: '/importingWithholdingCertificates/verifyDuplicatedEntries',
                headers: { 'content-type': 'application/json' },
                params: {
                    generatedCodes: Array.isArray(value?.generatedCodes)
                        ? value.generatedCodes.join(',')
                        : value?.generatedCodes || '',
                }
            };
            return new Promise((resolve, reject) => {
                axios(options)
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
}
